/*
  File: Dashboard.tsx
  Author: Binish Mookken
  Date: April-June 2024

  Description:
  This file contains the Dashboard component, which serves as the main view for users to manage their network information.
  It displays various components including AgentCard, AgentReferrals, AgentTree, and Header. The Header component provides
  contextual information about the network view. The AgentCard component displays the user's network details, while the
  AgentReferrals component shows the referrals made by the user's agents. Lastly, the AgentTree component visualizes the
  user's network hierarchy.
*/

import React from "react";
import AgentCard from "./AgentCard";
import AgentTree from "./AgentTree";
import { useAuth } from "./context/AuthContext";
import AgentReferrals from "./AgentReferrals";
import "./Dashboard.css";
import Header from "./Header";
import agentsIcon from "./icons/agents.gif";

const Dashboard: React.FC = () => {
  const { agentInstance } = useAuth();

  return (
    <div>
      <div className="dashboard">
        <div className="dashboard-container">
          {agentInstance != null && (
            <>
              <Header
                header="My Network"
                subheader="View your entire passive income network here."
                icon={agentsIcon}
              />
              <AgentCard agentInstance={agentInstance} />
              <AgentReferrals agentInstance={agentInstance} />
              <AgentTree agentInstance={agentInstance} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
